import {ActionContext} from 'vuex'
import { ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import ExportProfit from './entity'


interface ExportProfitState extends ListStateItem<ExportProfit>{
    editExportProfit:ExportProfit,
}

class ExportProfitModule extends ListModuleItem<ExportProfitState,any,ExportProfit>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editExportProfit:new ExportProfit(),
    }
    actions={
        async getAll(context:ActionContext<ExportProfitState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/DeclareCustoms/GetExportProfitPage',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<ExportProfit>;
            context.state.table.totalCount=page.totalCount;
           // page.items.push({shippingNumber:'',shipmentDate:null,customerName:'',ownerName:'',businessGroup='',factoryAmount=null,drawback=null,exchangeRate=null,amountReceivedUSD=null,amountReceivedRMB=null,bankDeduction=null,profitType='',profitMargin=null,remark='',factoryName=null,id=null,profit=null,freight=null,receiverAmount=123})
           page.items.push({shippingNumber:'',shipmentDate:null,shipmentDateStr:'合计',customerName:'',ownerName:'',businessGroup:'',factoryAmount:page.items.reduce((totalPrice, item) => totalPrice + item.factoryAmount, 0),drawback:page.items.reduce((totalPrice, item) => totalPrice + item.drawback, 0),exchangeRate:null,amountReceivedUSD:page.items.reduce((totalPrice, item) => totalPrice + item.amountReceivedUSD, 0),amountReceivedRMB:page.items.reduce((totalPrice, item) => totalPrice + item.amountReceivedRMB, 0),bankCharges:page.items.reduce((totalPrice, item) => totalPrice + item.bankCharges, 0),profitType:'',profitMargin:null,remark:'',factoryName:null,id:null,profit:page.items.reduce((totalPrice, item) => totalPrice + item.profit, 0),freight:page.items.reduce((totalPrice, item) => totalPrice + item.freight, 0),receiverAmount:page.items.reduce((totalPrice, item) => totalPrice + item.receiverAmount, 0)})
            context.state.table.list=page.items;
        },
             //新增
             async create(context: ActionContext<ExportProfitState, any>, payload: any) {
                await $http.post('services/app/DeclareCustoms/CreateExportProfit', payload.data);
            },
            //更新
            async update(context: ActionContext<ExportProfitState, any>, payload: any) {
                await $http.put('services/app/DeclareCustoms/UpdateExportProfit', payload.data);
            },
    };
    overrideMutations={
        edit(state:ExportProfitState,exportProfit:ExportProfit){
            state.editExportProfit=exportProfit;
        }
    }
}
const amountStatisticsModule=new ExportProfitModule();
export default amountStatisticsModule;